const initialState = {
    locations: []
};

const EmployeeAssessmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_EMPLOYEE_ASSESSMENTS_LOCATIONS":
            return {
                ...state,
                locations: action.payload
            };
        case "RESET_STORE":
            state = initialState
            return state;
    }

    return state;
}

export default EmployeeAssessmentsReducer;